import React from 'react';
import "./FaqItem.css";
import AnimatedContent from "./react-bits/AnimatedContent";

function FaqItem(props: {title: string, content: string}) {
    return (
        <AnimatedContent
            distance={50}
            direction="vertical"
            reverse={false}
            duration={0.8}
            ease="easeInOut"
            initialOpacity={0}
            animateOpacity={true}
            scale={1.02}
            threshold={0}
            delay={0.1}
        >
            <div className="faq-item">
                <h3>{props.title}</h3>
                <p>{props.content}</p>
            </div>
        </AnimatedContent>
    );
}

export default FaqItem;